var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',_vm._g(_vm._b({staticClass:"cbs-select-month"},'el-select',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.monthOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }